<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 id="sigil_toc_id_10">Epigraph</h2>
<p class="firstcenter"></p>
<p class="firstcenter"></p>
<p class="firstcenter"></p>
<p class="epi">The reward of the search is to go on searching. The soul’s desire is fulfilled by the very fact of its remaining unsatisfied, for really to see God is never to have had one’s fill of desiring Him.</p>
<p class="epi_source">Gregory of Nyssa</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?28c0adb3